import React from "react";
import PropTypes from "prop-types";
import BaseTextButton from "../../../../components/BaseTextButton";
import UserInfo from "../UserInfo";
import models from "../../../../types/models";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";
import "./style.scss";

export default observer(function MainUser({ user, activateEditProfile }) {
  MainUser.propTypes = {
    user: models.user,
    activateEditProfile: PropTypes.func.isRequired,
  };
  const { t } = useTranslation();

  return (
    <div className="personal-account-page__wrapper__user">
      <UserInfo
        name={user?.firstName}
        icon={user?.gender}
        email={user?.email}
        age={user?.age}
        hideMatches
      >
        <BaseTextButton
          className="personal-account-page__wrapper__user__edit-btn"
          icon="pencil"
          onClick={activateEditProfile}
        >
          {t("personal_acc.edit_profile")}
        </BaseTextButton>
      </UserInfo>
    </div>
  );
});
